// IMPORT
import React from "react";

// CSS
import './SolutionPurP.css';

// Graphics
import Graphic from '../global/graphics/Img_Purchasing.svg'

// Components
import CompHeading from '../../components/CompHeading'
import CompPictureText from "../../components/CompPictureText";

// SolutionPurP
export default function SolutionPurP() {
  return (
    <div className="SolutionPurP-Content page-gap">
      <CompHeading
        Title={"Einkaufsplanung"}
        Subheading={"KI-gestützte Einkaufsplanung durch Prognose der Bedarfe."}
      />
      <CompPictureText
        Title={"KI-gestützte Einkaufsplanung"}
        Subheading={""}
        Text={"Rohmaterial und Verbrauchsgüter müssen stets in ausreichender Menge bereitstehen. " + 
          "Zu wenig Bestand sorgt für Verzögerungen in der Fertigung, " + 
          "zu viel Lager verursacht hohe Kosten und kann zu Verfall führen. " + 
          "Fehlende Transparenz in Beschaffungsprozessen, geteilte Zuständigkeiten " + 
          "und plötzliche Peaks (z. B. durch Run) machen die Bedarfsplanung komplex. " + 
          "\n\nMit der intelligenten Beschaffungsplanung von Aixioom " + 
          "erzielen Sie optimale Lieferantenpreise, erhöhen Ihre Handelsspanne um bis zu 2% " + 
          "und gewährleisten eine kontinuierliche, effiziente Bedarfsdeckung."}
        Graphic={Graphic}
        GraphicAlt={"KI-gestützte Einkaufsplanung"}
      />
    </div>
  )
}
